import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSunrise: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sunrise"><path d="M12 2.75V3.77941M3.77778 12.25H2.75M20.2222 12.25H21.25M17.8134 6.19148L18.5401 5.46357M2.75 16.25H21.25M6.75 20.25H17.25M6.18671 6.19147L5.45996 5.46357M7.75 12.25V12.0068C7.75 9.65581 9.65279 7.75 12 7.75C14.3472 7.75 16.25 9.65581 16.25 12.0068V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSunrise;
